import { render } from "./PixWidget.vue?vue&type=template&id=740d56d6"
import script from "./PixWidget.vue?vue&type=script&lang=js"
export * from "./PixWidget.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__